import { MARKETING } from '@/config/marketing.config';
import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'hero-widget',
  standalone: true,
  imports: [ButtonModule],
  template: `
    <section class="py-12 px-6 md:px-12 lg:px-20">
      <div class="max-w-5xl">

        <h1 class="text-4xl md:text-5xl font-bold mb-4">
          {{ marketing.tagline }}
        </h1>

        <p class="text-xl text-color-secondary mb-6 max-w-3xl">
          {{ marketing.subTagline }}
        </p>

        <div class="flex flex-wrap gap-3 mb-4">
          <a
            pButton
            label="Try Live Demo"
            class="p-button-lg"
            [href]="marketing.demoUrl"
            target="_blank"
            rel="noopener"
          ></a>

          <a
            pButton
            label="How It Works"
            class="p-button-outlined p-button-lg"
            routerLink="/how-it-works"
          ></a>
        </div>

        <p class="text-sm text-color-secondary">
          Built for operations teams. Not a free-chat AI bot.
        </p>

      </div>
    </section>
  `
})
export class HeroWidget {
  marketing = MARKETING;
}
